// @flow
import React from 'react';
import moment from 'moment';

type Props = {
  promotions: Array<Object>
};

class SMHomePromotionListView extends React.Component {

  constructor(props: Props) {
    super(props);
  }

  renderPromotionsComponent(promotions: Array<Object>) {
    return (
      promotions.map((promotion, index)=>{
        if (index >= 3) return;
        const couponOrPointCode = promotion.coupon || promotion.point_code;
        const validAt = moment(couponOrPointCode.valid_at).utc();
        const expiresAt = moment(couponOrPointCode.expires_at).utc();
        return this.renderPromotionComponent(promotion, validAt, expiresAt);
      })
    );
  }

  renderPromotionComponent(promotion: Object, validAt: Object, expiresAt: Object) {
    return (
      <div key={promotion.id} className="col-xs-4 campaign-box">
        <a href={Routes.promotion_path(promotion)}>
          <div className="campaign-linkbox is-hover">
            <div className="md-top-units mdl-shadow--2dp">
              <img src={promotion.image} alt={promotion.title} />
              <h3 className="campaign-subtitle" style={{backgroundColor: promotion.background_color}}>
                <span className="campaign-subtitle__name">
                  {promotion.title}
                </span>
              </h3>
            </div>
            <p className="top-units__body-term">
              {moment(validAt).format("YYYY年M月D日")}〜{moment(expiresAt).format("YYYY年M月D日")}
            </p>
          </div>
        </a>
      </div>
    );
  }

  render() {
    return (
      <div className="container top-container">
        <div className="top-campaign__list">
          <div className="top-title__container clearfix">
            <h2 className="top-title">開催中のキャンペーン</h2>
            <a href={Routes.promotions_path()} className="pc-hide__sm-show top-more__area-link">もっと見る</a>
          </div>
          <div className="top-units__container">
            <div className="row">
              {this.renderPromotionsComponent(this.props.promotions)}
            </div>
          </div>
        </div>
        <div className="sm-hide top-more__area">
          <a href={Routes.promotions_path()} className="top-more__area-link">{I18n.t('service.label_000115')}</a>
        </div>
      </div>
    );
  }
}
export default SMHomePromotionListView;


// WEBPACK FOOTER //
// ./app/javascript/components/home/SMHomePromotionListView.jsx